// @ts-nocheck
import React, { useEffect } from "react";
import { ReactComponent as LightningIcon } from "../assets/icons/lightning.svg";
import { AssetBreadCrumb } from "../components/AssetBreadCrumb";
import { modalViewsConst, setModalState } from "../store/modalSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchPCurves, fetchSolarEnergyModels } from "../store/pCurveSlice";
import { getMyOrganizations } from "../store/userSlice";
import { PCurveTable } from "../components/PerformanceCurve/PCurveTable";

const PerformanceCurvePage = () => {
  const dispatch = useDispatch();
  const pCurve = useSelector((state) => state.pCurve);
  const { organizations } = useSelector((state) => state.user);

  const getPowerCurves = async () => {
    dispatch(fetchPCurves());
    dispatch(fetchSolarEnergyModels());
    
    // Load organizations data if not already loaded
    if (!organizations.loaded) {
      dispatch(getMyOrganizations());
    }
  };

  useEffect(() => {
    getPowerCurves();
  }, []);

  const handleNewPCurve = () => {
    dispatch(
      setModalState({
        modalOpen: true,
        modalView: modalViewsConst.energyModelSelect,
        properties: null,
      })
    );
  };

  return (
    <>
      <div className="relative w-full h-screen bg-white overflow-hidden">
        <div className="sticky top-0 left-0 right-0 z-10 bg-white">
          <AssetBreadCrumb text="Energy Models">
            <LightningIcon stroke="#6B7280" className="w-5 h-5 ml-2 mr-1" />
          </AssetBreadCrumb>
          <div className="flex flex-row h-24 border-t border-gray-200 px-10 pt-5 justify-left items-center">
            <div className="flex grow items-center">
              <div className="flex-col items-center justify-center">
                <div className="text-gray-900 text-xl font-semibold font-Inter mb-1">
                  All Energy Models
                </div>
                <div className="text-gray-500 text-sm font-normal font-Inter">
                  View and manage energy models, power curves, etc.
                </div>
              </div>
            </div>
            <button
              onClick={handleNewPCurve}
              className="flex-wrap eai-btn-grn my-1"
              type="submit"
            >
              <div className="mx-3">
                <span className="hidden md:block">+ Add Energy Model</span>
                <span className="block md:hidden">+</span>
              </div>
            </button>
          </div>
        </div>
        <div className="h-[calc(100vh-9rem)] px-10 pb-10 pt-5 overflow-y-auto">
            {pCurve?.data || pCurve?.solarData ? (
              <PCurveTable
                solarEnergyRecords={Object.values(pCurve.solarData)}
                pCurveRecords={Object.values(pCurve.data)}
              />
            ) : (
              <div className="text-center w-full">No data yet</div>
            )}
          </div>
      </div>
    </>
  );
};

export default PerformanceCurvePage;
